import React, { createRef} from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import MaterialTable from "material-table";

import FormEdit from "./FormEdit";
import { getCategories, getPaginateCategories, deleteCategory } from "../../actions/admin/category";
import { updateModalContent, toggleModal } from "../../actions/modal";


class CategoryList extends React.Component {
  
  _columns = [
    { title: "ID", field: "id", defaultSort: "asc" },
    {
        title: "Name",
        field: "name",
        render: category => {
            return (
                <span
                    onClick={() => this.onEditCategory(category)}
                    style={{ cursor: "pointer" }}
                    className="quick-edit"
                >
                  {category.name}
                </span>
            );
        }
    },
    { title: "Group", field: "group" }
  ];

  constructor(props){
    super(props);
    this.state = {
      pageSize: 5,
    }
    this.formEditRef = createRef();
  }
  
  _columns = [
    { title: "ID", field: "id", defaultSort: "asc" },
    {
      title: "Name",
      field: "name",
      render: category => {
        return (
          <span
            onClick={() => this.onEditCategory(category)}
            style={{ cursor: "pointer" }}
            className="quick-edit"
          >
            {category.name}
          </span>
        );
      }
    },
    { title: "Group", field: "group" }
  ];

  componentDidMount(){
    this.getAllCategories();
  }

  getAllCategories(){
    try {
      this.props.getCategories();
    } catch (error) {
      console.log('error in getAllCategories(): ');
      console.log(error);
    }
  }

  onEditCategory(category){
    this.props.updateModalContent({
      title: "Update Category",
      content: <FormEdit id={category.id} ref={this.formEditRef} />,
      actionButton: {
          actionText: "Update",
          actionType: "primary",
          // formEdit.submitForm() dispatches an action to update the store
          // and the update will be picked up here because our props.categories
          // is taken from the store.
          action: () => this.formEditRef.current.submitForm()
      },
      cancelText: "Cancel",
      closeAfterAction: false
    });
    this.props.toggleModal();
  }

  onDeleteCategory(id){
    // set the content of the modal
    this.props.updateModalContent({
      title: "Are you sure?",
      content: "All data related to this category will be deleted.",
      actionButton: {
          actionText: "Delete",
          actionType: "danger",
          action: () => {
            try {
              this.props.deleteCategory(id).then((response) => {
                if( response.status === 200 ){
                  toast.success("Category Deleted.");
                }else{
                  toast.error("An unexpected error has occurred");
                }
              })
              .catch((err) => {
                toast.error(err);
              });
            } catch (err) {
              toast.error(err)
            }
          }
      },
      cancelText: "Cancel",
      closeAfterAction: true
    });
    
    this.props.toggleModal();
  }

  render() {return (
      <div>
        {/** The pagination in MaterialTable is not a true pagination; if we provide
         * the entire data set it has a ability to show by pages and pageSize. 
         * If we have huge data set we will need an api to return the paginated
         * data set. Refer to /src/components/admin/category/List.js for how that is 
         * achieved in functional component.
          */}
        <MaterialTable
            title=""
            columns={this._columns}
            onChangeRowsPerPage={(pageSize) => {
                this.setState({pageSize});
            }}
            data={this.props.categories}
            actions={[
                {
                    icon: "edit",
                    tooltip: "Edit Category",
                    onClick: (event, category) => this.onEditCategory(category)
                },
                {
                    icon: "delete",
                    tooltip: "Delete Category",
                    onClick: (event, category) => this.onDeleteCategory(category.id)
                }
            ]}
            options={{
                actionsColumnIndex: -1,
                pageSize: this.state.pageSize,
                emptyRowsWhenPaging: false
            }}
        />
      </div>
    )
  }
}

// map props to redux state (use Chrome Redux DevTools to help identify how state are stored)
function mapStateToProps(state) {
  return {
    categories: state.admin.category.categories
  };
}

// map the redux action creators to props
const mapActionToProps = {
  deleteCategory, getCategories, getPaginateCategories, updateModalContent, toggleModal
}

// connect(mapStateToProps, actions to component as props)(component)
export default connect(
  mapStateToProps, 
  mapActionToProps
)(CategoryList);